import { useState } from "react";
import { useForm } from "react-hook-form";
import { LoadingPage } from "../../../shared/components/LoadingPage";
import { Sidebar } from "../../../shared/components/MenuSidebar/Sidebar";
import { Navbar } from "../../../shared/components/Navbar";
import { PageHeader } from "../../../shared/components/PageHeader/PageHeader";
import { TableInfo } from "../../../shared/components/Table";
import { IconAudit } from "../../../shared/Icons/IconAudit";
import { IconVisibility } from "../../../shared/Icons/IconVisibility";
import { FiltroAuditoria } from "../components/FiltroAuditoria";
import { ModalVisualizar } from "../components/ModalVisualizar";
import { useGetAuditoria } from "../hooks/useGetAuditoria";
import { colunas } from "../utils/ColumnList";
import { Tabela } from "../utils/TabelaData";


const InitialValue = {Usuario: '', Tabela: '', DataCriacao: ''}

export function Auditoria() {
  const [visible, setVisible] = useState<boolean>(false);
  const [dataSearch, setDataSearch] = useState(InitialValue);
  const [page, setPage] = useState<number>(1);
  const [auditoriaId, setAuditoriaId] = useState<number>();

  const { handleSubmit, control } = useForm();

  const { data, isLoading } = useGetAuditoria(dataSearch, page);

  const dataAuditoria = data?.items?.map((items: any, index: number) => ({
    ...items,
    key: index,
  }));

  function onSubmit(data: any, e: any) {
    e.preventDefault();
    setDataSearch(data);
    if(data) {
      setPage(1);
    }
  }

  const columns = [
    ...colunas,
    {
      title: "Ações",
      dataIndex: "action",
      key: "action",
      width: 50,
      render: (text: any, record: any, index: any) => {
        return (
          <div className=" flex justify-center gap-3">
            <button
              className="bg-gray-400 hover:bg-primary-hover p-1 text-gray-100 rounded-full"
              onClick={() => {
                setVisible(!visible);
                setAuditoriaId(record.AuditoriaId);
              }}
            >
              <IconVisibility width="20" height="20" />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <div className="flex flex-row mx-auto">
      <div className="flex flex-row">
        <Sidebar />
        <Navbar />
      </div>

      <div className="flex flex-col pl-[10rem] w-[85%] mx-auto">
        <PageHeader 
          titulo="Auditoria"
          icon={<IconAudit width="30"/>}
          componente={
            <div className="flex gap-3">
              <FiltroAuditoria 
                tabelaDataSource={Tabela} 
                control={control}
                onSubmit={handleSubmit(onSubmit)}
              />
            </div>
          }
        />

        {isLoading ?
          (
            <div className="h-[80vh] flex justify-center items-center">
              <LoadingPage />
            </div>
          ) :
          (
            <TableInfo
              columns={columns}
              dataSource={dataAuditoria}
              pagination={{
                current: page,
                pageSize: data?.meta?.itemsPerPage,
                total: data?.meta?.totalItems,
                onChange(p) {
                  setPage(p);
                }
              }}
            />
          )
        }

        {auditoriaId && <ModalVisualizar
          visible={visible}
          onCancel={() => setVisible(!visible)}
          auditoriaId={auditoriaId!}
        />}
        
      </div>
    </div>
  );
}
